"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["className", "datas", "name", "formName", "formValues", "mode", "params", "position", "wrapper", "wrapperFunc"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var object_hash_1 = __importDefault(require("object-hash"));

var react_1 = __importDefault(require("react"));

var redux_form_1 = require("redux-form");

var index_1 = __importDefault(require("../index"));

var SectionSC = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var DataSection = function DataSection(_ref) {
  var className = _ref.className,
      datas = _ref.datas,
      name = _ref.name,
      formName = _ref.formName,
      formValues = _ref.formValues,
      mode = _ref.mode,
      params = _ref.params,
      position = _ref.position,
      wrapper = _ref.wrapper,
      wrapperFunc = _ref.wrapperFunc,
      props = _objectWithoutProperties(_ref, _excluded);

  var newDatas = datas && !Array.isArray(datas) ? [datas] : datas;
  return react_1.default.createElement(SectionSC, _objectSpread({
    className: className
  }, props), react_1.default.createElement(redux_form_1.FormSection, {
    name: name
  }, newDatas && newDatas.length > 0 && newDatas.map(function (data, index) {
    return react_1.default.createElement(index_1.default, _objectSpread(_objectSpread({
      key: (0, object_hash_1.default)(_objectSpread(_objectSpread({}, data), {}, {
        datas: null,
        params: null
      }))
    }, data), {}, {
      formName: formName,
      formValues: formValues,
      mode: mode,
      params: params,
      position: "".concat(position ? "".concat(position, ".") : '').concat(name, "[").concat(index, "]"),
      wrapper: wrapper,
      wrapperFunc: wrapperFunc
    }));
  })));
};

exports.default = DataSection;